module.exports = __webpack_public_path__ + "Roboto-Thin.44b78f142603eb69f593.woff";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/node_modules/materialize-css/dist/fonts/roboto/Roboto-Thin.woff
// module id = ../../../../materialize-css/dist/fonts/roboto/Roboto-Thin.woff
// module chunks = vendor